import React, { useContext, useEffect, useState } from "react";
import TableHeader from "../Common/TableHeader";
import SchoolContext from "../../Context/SchoolContext";
import ajaxBank from "../../util/remote/ajaxBank";
import Select from "react-select";
import Loader from "../Common/Loader";

function VendorsTransactionStatus() {
    const {schoolList} = useContext(SchoolContext); 
    const [school, setSchool] = useState(2);
    const [schoolDashboardVendors, setSchoolDashboardVendors] = useState([]);
    const [loading, setLoading] = useState(false);
    
    useEffect(()=>{
        getSchoolDashboardVendors();
     }, [school])

    const getSchoolDashboardVendors = async (e) => {
        if (e) {
            e.preventDefault();
        }
        setLoading(true)
        const server_response = await ajaxBank.fetchSchoolDashboardVendors(school);
        setLoading(false)
        if (server_response.status === "OK") {
          setSchoolDashboardVendors(server_response.details);
        } else {
          setSchoolDashboardVendors("404");
        }
      };

    return (
        <>
            <div className="heading-layout1 mg-b-5">
                <TableHeader
                    subtitle="List of all the vendors per school and their transaction status today"
                />
            
            </div>
            <form className="mg-t-20" onSubmit={getSchoolDashboardVendors}>
                    <div className="row gutters-8">
                    <div className="col-10-xxxl col-lg-10 col-12 form-group">
                        <div className="row">
                            
                        
                        <div className="col-lg-12 mt-2">
                        <Select
                            onChange={(e) => setSchool(e.school_id)}
                            getOptionLabel={(option) => option.school_name}
                            getOptionValue={(option) => option.school_id}
                            isSearchable
                            placeholder="Select school..."
                            options={Array.isArray(schoolList) ? schoolList : []}
                            value={
                                    school === "" ? null
                                        : Array.isArray(schoolList) &&
                                        schoolList.find((value) => value.school_id === school)
                                    }
                            
                        />
                        </div>
                        
                        
                        
                        </div>
                    </div>
            
                    <div className="col-2-xxxl col-lg-2 col-12 form-group">
                        <button
                        type="submit"
                        className="btn-fill-lmd radius-30 text-light shadow-dodger-blue bg-dodger-blue ml-2"
                        >
                        SEARCH
                        </button>
                        
                    </div>
                    </div>
            </form>
            <div className="border-top mt-3"></div>
            <div className="table-responsive">
                {loading ? (
                          <Loader />
                        ) : (
                          <table className="table table-hover text-nowrap mg-b-0">
                        <thead>
                            <tr>
                            <th>No.</th>
                            <th>Vendor Name</th>
                            <th>Transactions Today</th>
                            <th>Recent Transaction</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Array.isArray(schoolDashboardVendors) &&
                            schoolDashboardVendors.map((item, key) => (
                                <tr key={key}>
                                    <td>{key + 1}</td>
                                    <td>{item.vendor_name}</td>
                                    <td>{item.transactions_count?.total_p}</td>
                                    <td><span class="badge badge-info">{item.recent_transaction_type}</span><br/><small>{item.created_at}</small></td>

                                
                                </tr>
                            ))}
                            {schoolDashboardVendors === "404" && (
                            <tr>
                                <td colSpan="4" style={{ textAlign: "center" }}>
                                No vendor transactions today.
                                </td>
                            </tr>
                            )}
                        </tbody>
                    </table>
                        )}
                    
            </div>
        </>
        
    );
}

export default VendorsTransactionStatus;
